import {Map} from 'immutable';
import type {GetCollectionsResponse} from '@packages/systems/cms/types';
import {
  reifyCollections,
  sortCollectionsBySortPos,
} from '@packages/systems/dynamo/utils/CollectionUtils';
import type {CollectionsType} from '@packages/systems/core/records/CollectionStateType';
import {addInventoryFieldToSkuCollection} from '@packages/systems/commerce/utils/CommerceCollectionUtils';
import {maybeAddNoSearchFieldToCollections} from './maybeAddNoSearchFieldToCollections';
import {compose} from '@packages/utilities/fp/utils';

export default function prepareCollections(
  jsonCollections?: GetCollectionsResponse
): {collections: CollectionsType; shouldUpgradeCollections: boolean} {
  if (!jsonCollections) {
    return {collections: Map(), shouldUpgradeCollections: false};
  }

  // Within the beta, we want to upgrade collections if there
  // are any collections missing the _noSearch field.
  const shouldUpgradeCollections = jsonCollections.some(
    (collection) =>
      !collection.fields.some((field) => field?.slug === '_noSearch')
  );

  // We add inventory field to the SKU collection so that it will be available for dynamic binding.
  // We don't want to persist it on the collection however because this can cause performance issues.
  // See https://github.com/webflow/webflow/pull/36756 for more details.
  const collections = sortCollectionsBySortPos(
    compose(addInventoryFieldToSkuCollection)(reifyCollections)(jsonCollections)
  );

  return {
    collections: shouldUpgradeCollections
      ? maybeAddNoSearchFieldToCollections(collections)
      : collections,
    shouldUpgradeCollections,
  };
}
